<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('stockTransfer.transferBySerial') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockTransfer.transferBySerial'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-3">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'transfer-by-serial-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-4 d-flex justify-content-end">
            <div class="btn-group btn-group-justified">
              <a
                class="btn btn-default"
                :class="{ 'btn-info': transfered }"
                :disabled="loading"
                @click.prevent="transfere"
              >
                {{ $t('stockTransfer.transfered') }}
              </a>
              <a
                class="btn btn-default"
                :class="{ 'btn-info': recieved }"
                :disabled="loading"
                @click.prevent="recieve"
              >
                {{ $t('stockTransfer.recieved') }}
              </a>
            </div>
          </div>
          <div class="col-sm-12 col-md-5 d-flex justify-content-end">
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width:600px"
              @change="fetchData"
              class="mr-2"
            />
            <select
              class="form-control mr-2"
              style="width: 120px"
              v-model="status_id"
              @change="fetchData"
            >
              <option :value="null">
                {{ $t('All') }}
              </option>
              <option
                v-for="(s, index) in transferStatus"
                :key="index"
                :value="s.value"
              >
                {{ s.label }}
              </option>
            </select>
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              v-tooltip="$t('stockTransfer.search')"
              class="mr-2"
            />
            <ts-button
              outline
              v-tooltip="$t('stockTransfer.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'transfer_date'
          }"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.transfer_no }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.from_branch ? record.from_branch.branch_name_en : '' }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{
                record.from_location
                  ? record.from_location.location_name_en
                  : ''
              }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{
                record.transferred_by
                  ? record.transferred_by.employee
                    ? record.transferred_by.employee.employee_name_en
                    : ''
                  : ''
              }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.to_branch ? record.to_branch.branch_name_en : '' }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{
                record.to_location ? record.to_location.location_name_en : ''
              }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{
                record.received_by
                  ? record.received_by.employee
                    ? record.received_by.employee.employee_name_en
                    : ''
                  : ''
              }}
            </td>
            <td
              class="ts-whitespace-no-wrap text-center"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.received_date }}
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              <span :class="statusStyle(record.transfer_status_id)">{{
                status(record.transfer_status_id)
              }}</span>
            </td>
            <td
              class="ts-whitespace-no-wrap"
              :style="rowStyle(record.transfer_status_id)"
            >
              {{ record.received_comment }}
            </td>
            <td
              class="ts-whitespace-no-wrap text-center"
              :style="rowStyle(record.transfer_status_id)"
            >
              <a
                href="#"
                v-tooltip="$t('pdf')"
                class="mr-2 ml-2 text-red"
                @click.prevent="print(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('view')"
                class="text-info"
                @click.prevent="view(record)"
              >
                <i class="fas fa-eye"></i>
              </a>
              <!-- <span v-if="record.transfer_status_id == 1">
                <a
                  v-if="transfer_type === 'recieved'"
                  href="#"
                  v-tooltip="'Confirm'"
                  class="ml-2 mr-2 text-success"
                  @click.prevent="confirm(record)"
                >
                  <i class="far fa-check-circle"></i>
                </a>
                <a
                  v-if="transfer_type === 'recieved'"
                  href="#"
                  v-tooltip="'Reject'"
                  class="text-warning"
                  @click.prevent="reject(record)"
                >
                  <i class="far fa-times-circle"></i>
                </a>
              </span> -->
              <span
                v-if="
                  record.transfer_status_id == 1 ||
                    record.transfer_status_id == 3
                "
              >
                <a
                  v-if="transfer_type === 'transfered'"
                  href="#"
                  v-tooltip="$t('edit')"
                  class="mr-2 ml-2 text-primary"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  v-if="transfer_type === 'transfered'"
                  href="#"
                  v-tooltip="$t('delete')"
                  class="text-danger"
                  @click.prevent="destroy(record)"
                  :disabled="record._deleting"
                >
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fas fa-trash" v-else></i>
                </a>
              </span>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto detail">
              <thead>
                <tr>
                  <th>{{ $t('stockTransfer.barcode') }}</th>
                  <th>{{ $t('stockTransfer.group') }}</th>
                  <th>{{ $t('stockTransfer.product') }}</th>
                  <th class="text-center">{{ $t('stockTransfer.uom') }}</th>
                  <th class="text-center">
                    {{ $t('stockTransfer.qty') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(detail, index) in prop.record.stock_transfer_details"
                  :key="index"
                >
                  <td class="ts-p-1">
                    {{ detail.product ? detail.product.barcode : '' }}
                  </td>
                  <td class="ts-p-1">
                    {{ detail.product ? detail.product.pro_group_name_en : '' }}
                  </td>
                  <td class="ts-p-1">
                    {{ detail.product ? detail.product.product_name_en : '' }}
                  </td>
                  <td class="ts-p-1 text-center">
                    {{
                      detail.unit_of_measure
                        ? detail.unit_of_measure.uom_name_en
                        : ''
                    }}
                  </td>
                  <td class="ts-p-1 text-center">{{ detail.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('stockTransfer.filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label v-if="transfer_type == 'transfered'">
              {{ $t('stockTransfer.from_location') }}
            </label>
            <label v-else>
              {{ $t('stockTransfer.to_location') }}
            </label>
            <ts-location-filter @filter="filterLocaton"></ts-location-filter>
          </div>
        </div>
      </div>
    </a-drawer>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import RejectReason from './components/reason-reject.vue'

export default {
  name: 'transfer-by-serial',
  data () {
    return {
      loading: false,
      waiting: false,
      show_pdf: false,
      src: '',
      transfered: 'active',
      recieved: '',
      visible: false,
      branch_id: [],
      transferStatus: [
        {
          value: 1,
          label: 'Pending'
        },
        {
          value: 2,
          label: 'Recieved'
        },
        {
          value: 3,
          label: 'Rejected'
        }
      ]
    }
  },
  computed: {
    ...mapState('stock/transferBySerial', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.stock.transferBySerial.search
      },
      set (newValue) {
        this.$store.commit('stock/transferBySerial/SET_SEARCH', newValue)
        this.$store.commit('stock/transferBySerial/RESET_CURRENT_PAGE')
      }
    },
    status_id: {
      get () {
        return this.$store.state.stock.transferBySerial.status_id
      },
      set (newValue) {
        this.$store.commit('stock/transferBySerial/SET_STATUS_ID', newValue)
      }
    },
    transfer_type: {
      get () {
        return this.$store.state.stock.transferBySerial.transfer_type
      },
      set (val) {
        this.$store.commit('stock/transferBySerial/SET_TRANSFER_TYPE', val)
      }
    },
    dateRange: {
      get () {
        return this.$store.state.stock.transferBySerial.dateRange
      },
      set (newValue) {
        this.$store.commit('stock/transferBySerial/SET_DATE_RANGE', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('stockTransfer.transfer') },
        { name: this.$t('stockTransfer.from_branch') },
        { name: this.$t('stockTransfer.from_location') },
        { name: this.$t('stockTransfer.transfered_by') },
        { name: this.$t('stockTransfer.to_branch') },
        { name: this.$t('stockTransfer.to_location') },
        { name: this.$t('stockTransfer.recieved_by') },
        {
          name: this.$t('stockTransfer.recieved_date'),
          style: 'text-align:center;'
        },
        { name: this.$t('stockTransfer.status') },
        { name: this.$t('stockTransfer.reason') },
        {
          name: this.$t('stockTransfer.actions'),
          style: 'text-align:center; width:2%'
        }
      ]
    },
    rowStyle: () => status => {
      let color = ''

      switch (status) {
        case 1:
          color = ''
          break
        case 2:
          color = ''
          break
        case 3:
          color = '#90949c'
          break
      }

      return {
        color: color
      }
    },
    statusStyle: () => status => {
      let badge = ''

      switch (status) {
        case 1:
          badge = 'badge badge-info'
          break
        case 2:
          badge = 'badge badge-primary'
          break
        case 3:
          badge = 'badge badge-default'
          break
      }

      return badge
    },
    status: () => status => {
      let value = ''

      switch (status) {
        case 1:
          value = 'Pending'
          break
        case 2:
          value = 'Recieved'
          break
        case 3:
          value = 'Rejected'
          break
      }

      return value
    }
  },
  created () {
    this.transfer_type = 'transfered'
    this.fetchData()
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'stock/transferBySerial/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    filterLocaton (value) {
      this.$store.commit('stock/transferBySerial/SET_LOCATION_ID', value)
      this.fetchData()
    },
    edit (record) {
      this.$store.commit('stock/transferBySerial/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'transfer-by-serial-edit',
        params: { id: record.stock_transfer_id }
      })
    },
    transfere () {
      this.transfer_type = 'transfered'
      this.transfered = 'active'
      this.recieved = ''
    },
    recieve () {
      this.transfer_type = 'recieved'
      this.recieved = 'active'
      this.transfered = ''
    },
    async destroy (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('stock/transferBySerial/destroy', record.stock_transfer_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            if (
              error.message ===
              'The current user not yet belong to any warehouses.'
            ) {
              this.$toasted.info(error.message)
            } else {
              this.$toasted.error(error.message)
            }
            record._deleting = false
          })
      }
    },
    async confirm (record) {
      if (
        await this.$confirmModal(
          this.$t('stockTransfer.are_you_sure_to_confirm')
        )
      ) {
        record._deleting = true
        this.$store
          .dispatch('stock/transferBySerial/confirm', {
            stock_transfer_id: record.stock_transfer_id,
            transfer_status_id: 2
          })
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            if (
              error.message ===
                'The current user not yet belong to any warehouses.' ||
              error.message ===
                'Transferred and recieved user must be defferent.'
            ) {
              this.$toasted.info(error.message)
            } else {
              this.$toasted.error(error.message)
            }
            record._deleting = false
          })
      }
    },
    reject (record) {
      this.$modal.show(
        RejectReason,
        {
          record: record
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    view (data) {
      this.$store.commit('stock/transferBySerial/SET_EDIT_DATA', data)
      this.$router.push({
        name: 'transfer-by-serial-show',
        params: { id: data.stock_transfer_id }
      })
    },
    format_number (value) {
      return parseFloat(value).toFixed(2)
    },
    print (record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('stock/transferBySerial/printPdf', {
          stock_transfer_id: record.stock_transfer_id,
          report_template: 'transfer-by-serial'
        })
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    transfer_type: function (data) {
      this.$store.commit('stock/transferBySerial/RESET_STATE')
      this.fetchData()
    },
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'transfer-by-serial-create') {
      this.$store.commit('stock/transferBySerial/RESET_STATE')
    }
    next()
  }
}
</script>
<style scoped>
.detail td {
  padding: 0.2rem;
}
</style>
